import { FETCH_FULL_SERVICE } from '../actions/Types'
const initial_state = {
    subcategory: [], services: {}
}
const AllServicesReducer = (state=initial_state, action) => {
    switch(action.type){
        case FETCH_FULL_SERVICE:
            let services = {}
            let subcategory = []
            for (let element of action.payload){
                let temp = {}
                services[element.slug] = element.services
                temp.id = element.id
                temp.name = element.name
                temp.slug = element.slug
                subcategory.push(temp)
            }
            return { subcategory: subcategory, services: services }
        default:
            return state 
    }
}
export default AllServicesReducer